// extracted by mini-css-extract-plugin
export var accent = "_8k-4";
export var add = "_8k-j";
export var addIcon = "_8k-k";
export var deleteIcon = "_8k-i";
export var disabled = "_8k-9";
export var ellipsis = "_8k-f";
export var error = "_8k-3";
export var form = "_8k-5";
export var hideFocus = "_8k-2";
export var icon = "_8k-7";
export var input = "_8k-e";
export var listItem = "_8k-h";
export var mediumHeight = "_8k-b";
export var noBorder = "_8k-8";
export var noRadius = "_8k-1";
export var shortHeight = "_8k-a";
export var tallHeight = "_8k-c";
export var textInput = "_8k-0";
export var vertical = "_8k-g";
export var veryTallHeight = "_8k-d";
export var widget = "_8k-6";